import {
  createRecommendations,
  getPsykheRecommendations,
  sendProductListViewEvent,
} from "@/helpers/psykheHelper";
import ProductItemTile from "../ProductListingComp/ProductItemTile";
import { useEffect, useReducer, useState, useRef } from "react";
import { useSelector } from "react-redux";
import CustomMDesktopPagination from "../PLP-2.0/CustomDesktopPagination";
import { defaultPaginationParams, paginationHelper } from "./PaginationHelper";
import PsykheSortBy from "./PsykheSortBy";
import { generalConstants } from "@/utils/constants";
import CustomFilters from "../CustomFilters";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { useRouter } from "next/router";
import SelectedFiltersBar from "../CustomFilters/selectedFilters";
import useMediaQuery from "@/helpers/hooks/useMediaQuery";
import { ContentTilePLP1, ContentTilePLP2 } from "../PLP-2.0/BuilderContentTileNew";
import { generateFilterQuery } from "@/helpers/hooks/generateFilterQuery";
import { HiddenFiltersContext } from "../CustomFilters/HiddenFiltersContext";
import PLPQuickLinks from "../BuilderIO/ImageQuickLinks/ImageQuickLinks.builder";
import SeoDefinition from "../Header/SeoDefinition";
import BreadCrumb from "./BreadCrumb";
import { setCustomer } from "../common/Nosto";
import StatsComp from "./IntroComp";
import { useIntersection } from "@/components/common/UseIntersection";
import { BuilderComponent, useIsPreviewing } from "@builder.io/react";
import { isPsykhePLPCheck } from "@/helpers/plpHelper";

// DO NOT DELETE COMMENTED CODE
// COMMENTED CODE IS FOR FUTURE REFERENCE AND CAN BE USED WHEN NEEDED
// COMMENTED CODE CONTAINS FILTERS, SORTING, PAGINATION LOGIC AND FETCH RECOMMENDATIONS LOGIC
const PsykhePLP = ({ psykheData, seoData, urlQueryParams, contentTilePLPOne, contentTilePLPTwo, isMobile, quickLinks, serverPath, plpRender, apiType, referer, pagenum, urlChangeNeeded, newPageURL, oliSearch }) => {
  
  //OS-6100 if because of server side call cookie is not set then set the cookie
  if(psykheData?.variant) {
    // After you get psykheData
    setCookie("isPsykhe", psykheData?.variant);
  }
  const isPsykhe = getCookie("isPsykhe");
  console.log(isPsykhe,"===========isPsykhe==============")
  const isTablet = useMediaQuery("(max-width: 1024px)");
  const position1 = 6;
  const position2 = isTablet ? 18 : 19;
  let enableContentTile, enableContentTileCheck;
  enableContentTile = contentTilePLPOne || contentTilePLPTwo ? true : false;
  enableContentTileCheck = contentTilePLPOne || contentTilePLPTwo ? true : false;
  let relativePath = serverPath;
  const isDesignerPLP = relativePath?.includes("/designer");
  const isNewArrivalsPLP = relativePath?.includes("/new-arrivals");
  const isCollectionPLP = relativePath?.includes("/collection/");

  const [recommendations, setRecommendations] = useState(psykheData || {});
  const isPreviewing = useIsPreviewing();
   // Lazy load PDP Impact Content when visible using useIntersection
  const impactContentRef = useRef(null);
  // Set initialState to false for lazy loading, rootMargin to '200px' for preloading before fully in view
  const impactContentVisible = useIntersection(impactContentRef, "200px", false);

  // Initialize activeSortOption using the sort property from urlQueryParams
  const [activeSortOption, setActiveSortOption] = useState(() => {
    const sortOptions = [
      { key: "psykhe", label: "Featured" },
      { key: "n_maxPrice_asc", label: "Price Low to High" },
      { key: "n_maxPrice_desc", label: "Price High to Low" },
    ];

    // Find the matching sort option or default to "Featured"
    return sortOptions.find((option) => option.key === urlQueryParams?.sort) || sortOptions[0];
  });

  // Initialize filters using the filters property from urlQueryParams
  const [filters, setFilters, visibleFilters, hiddenFilters] = generateFilterQuery(urlQueryParams);

  
  // Get user data from Redux
  const logUser = useSelector((state) => state.loginUser);
  const userId = logUser?.userData?.id;
  const router = useRouter()

  // Set initial pagination object based on recommendations data
  const alterDefaultPaginationParams = {
    ...defaultPaginationParams,
    totalFetchedProducts: psykheData?.totalItems ? psykheData?.totalItems : recommendations.totalItems,
    totalPages: psykheData?.totalItems && plpRender ? (Math.ceil(
      psykheData?.totalItems / generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE
    )) : recommendations?.totalItems && plpRender ? (Math.ceil(
      psykheData?.totalItems / generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE
    )) : 3,
    enableContentTile: enableContentTileCheck,
    plpRender:plpRender,
  };

  // Handle custom pagination
  const [paginationState, dispatch] = useReducer(paginationHelper, alterDefaultPaginationParams);

  const isPsykhePLP = isPsykhePLPCheck(router.pathname);
  // guide the users to the top when recommendation are created
  const scrollToTop = () => {
    if(typeof window !== "undefined") {
      if ('scrollRestoration' in window.history) {
        if (router.pathname === "/for-you" || isPsykhePLP) {
          window.history.scrollRestoration = 'manual';
        } else {
          window.history.scrollRestoration = 'auto';
        }
      }
    }
  }

  // Create new recommendations based on sort, filters, and user ID
  const createNewRecommendations = async (sort, filters, id) => {
    const res = await createRecommendations(sort, filters, id, enableContentTileCheck, plpRender);
    if (res) {
      // if recommendations are fetched successfully, update the state and pagination and jump to page 1
      // set the below cookie with expiry
      setCookie("recoId", res.recoId, { expires: new Date(res.expiresAt * 1000) });

      setRecommendations(res);
      dispatch({
        type: "UPDATE_INITIAL_PAGINATION_PARAMS",
        payload: {
          pageData: {
            totalFetchedProducts: res?.totalItems,
            totalPages: plpRender ? (Math.ceil(
              res?.totalItems / generalConstants.NO_OF_ITEMS_PER_PAGE_PSYKHE
            )) : 3,
            enableContentTile: enableContentTileCheck,
            plpRender:plpRender,
            currentPage:1
          },
          shouldChangeURL: true
        },
      });
      scrollToTop()
    }
  };

  // Fetch recommendations based on the current offset. To be used only for pagination
  const fetchRecommendations = async (id, offset, length) => {
    const newRecommendations = await getPsykheRecommendations(id, offset, length);
    if (newRecommendations) {
      // set only the items in the recommendations state
      setRecommendations((prev) => ({
        ...prev,
        items: newRecommendations || [],
      }));
    }
  };
  
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const filterBarRef = useRef(null);
  const filterStartRef = useRef(null); // to mark the start of filter for intersection observer
  const [isFilterBarFixed, setIsFilterBarFixed] = useState(false);
  const wishlistSidebarOpen = useSelector(
    (state) => state.wishlist.open_wishlist_sidebar
  );
  const isMenuVisible = useSelector(
    (state) => state.header.isMenuVisible
  );
  const basketSidebarOpen = useSelector(
    (state) => state.click.open_mini_cart
  );
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );

  // OS-6382 : useEffect to track scroll and set the filter bar to sticky
  useEffect(() => {
    if(!filterStartRef.current) return;

    setIsFilterBarFixed(false);

    // allow custom offset
    const offset = isDesktop ? 250 : 200;

    const getTopPosition = () => {
      const rect = filterStartRef.current.getBoundingClientRect();
      return rect.top + window.scrollY;
    };
    let ticking = false;
    let topPosition = getTopPosition();

    const handleScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const plpQuickLinksEl = document.querySelector('.plpQuickLinks');
          let isQuickLinksOutOfView = false;
          if (plpQuickLinksEl) {
            const rect = plpQuickLinksEl.getBoundingClientRect();
            // Element is out of view if its bottom is above the top of the viewport
            isQuickLinksOutOfView = rect.bottom <= 0;
          } else {
            // If .plpQuickLinks is not found, fallback to original scroll condition
            isQuickLinksOutOfView = true;
          }
          setIsFilterBarFixed((scrollY >= topPosition - offset) && isQuickLinksOutOfView);
          ticking = false;
        });
      }
    };

    const handleResize = () => {
      topPosition = getTopPosition(); //recalc on resize
      handleScroll();
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleResize);

    handleResize();
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    }
  }, [router.asPath, isDesktop, filterStartRef.current]);

  useEffect(() => {
    //set customer nosto api
    setCustomer(logUser.user_loggedIn.accessToken);
    // Only run on client
    if (typeof window === "undefined") return;
    if(urlChangeNeeded && newPageURL) {
      // If urlChangeNeeded is true, replace the URL with newPageURL
      router.replace(newPageURL, undefined, { shallow: true });
    }
  }, []);

  useEffect(() => {
    console.log(apiType,referer,'===========referer=================')
    setCookie("psykheTileClick", "no");
    setCookie("forYouReferrer", referer);
    // const searchParams = new URLSearchParams(window.location.search);
    // const pageNumberInURL = searchParams.get("page");
    // let pageNumber = pageNumberInURL ? Number(pageNumberInURL) > paginationState.totalPages || psykheData?.isCreated ? 1 : Number(pageNumberInURL) : null;
    // //for dresses plp we dont wat to restrict till page 3
    // // if(plpRender){
    // //   pageNumber = false;
    // // }
    // // If page number is present in the URL, set the pagination state accordingly
    // if (pageNumber && apiType !== 'get') {
    //   dispatch({
    //     type: "UPDATE_INITIAL_PAGINATION_PARAMS",
    //     payload: { shouldChangeURL: true },
    //   });
    // }

    // Listen for URL changes via the back button
    const handlePopState = () => {
      const newSearchParams = new URLSearchParams(window.location.search);
      const newPageNumber = newSearchParams.get('page');
      if (newPageNumber) {
        dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: Number(newPageNumber), shouldChangeURL: false, enableContentTileCheck, plpRender } });
      } else {
        // if there is no page number, consider it be page 1
        dispatch({ type: "FETCH_DATA_FOR_SELECTED_PAGE", payload: { page: 1, shouldChangeURL: false, enableContentTileCheck, plpRender } });
      }
    };

    const newSearchParams = new URLSearchParams(window.location.search);
    const newPageNumber = newSearchParams.get('page');
    const pageNumberFromParams = newPageNumber && apiType === 'get' ? Number(newPageNumber) : 1;
    dispatch({ type: "UPDATE_INITIAL_PAGINATION_PARAMS", 
      payload: { 
        pageData: 
        {
          currentPage: pageNumberFromParams,
          enableContentTile: enableContentTileCheck,
          plpRender:plpRender
        }, 
        shouldChangeURL: apiType !== 'get'
      } 
    });

    window.addEventListener('popstate', handlePopState);

    // Conditionally scroll to top if apiType is 'create'
    // if (apiType !== "get") {
    //   scrollToTop();
    // }

    // If no recommendations data is present from server, create new recommendations
    if ((!psykheData || Object.keys(psykheData).length < 1) && !recommendations.items) {
      // add loader for PLP page
      if (typeof document !== undefined) {
        document.querySelector(".for-plp-loading")?.classList.add("loading");
      }
      let cid = null
      if(getCookie("_userId")) {
        cid = getCookie("_userId")
      }
      createNewRecommendations(activeSortOption?.key ? activeSortOption?.key : sortOptions[0], filters, cid);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
      // dispatch({
      //   type: "RESET_PAGINATION_PARAMS",
      //   payload: alterDefaultPaginationParams,
      // });
    };
  }, []);

  // Restore scroll position on mount
  useEffect(() => {
    if(isMobile){
      let scrollData = window.history.state?.plpScroll;
      if (!scrollData) {
        const sessionData = sessionStorage.getItem("plp-scroll-data");
        if (sessionData) scrollData = JSON.parse(sessionData);
      }
      if (scrollData && typeof scrollData.scrollY === "number") {
        setTimeout(() => {
          window.scrollTo({ top: scrollData.scrollY, behavior: "auto" });
        }, 0);
        sessionStorage.removeItem("plp-scroll-data");
        window.history.replaceState({ ...window.history.state, plpScroll: null }, "");
      }
    }
  }, [recommendations?.items]);

  // Fetch recommendations when pagination offset changes
  useEffect(() => {
    // if recommendations already exist and are not expired, then fetch next page
    // else create new recommendations
    if (paginationState.offset !== null) {
      let cookiedRecoId = getCookie("recoId");
      let recommendation_id =
        recommendations?.recoId &&
        recommendations?.expiresAt &&
        new Date(recommendations.expiresAt * 1000) > new Date(Date.now())
          ? recommendations.recoId
          : cookiedRecoId
          ? cookiedRecoId
          : null;
      if (recommendation_id) {
        fetchRecommendations(recommendation_id, paginationState.offset, paginationState.length);
      } else {
        createNewRecommendations(activeSortOption?.key, filters, userId);
      }
    }
  }, [paginationState.offset]);

  useEffect(() => {
    if(recommendations?.items?.length > 0){
      let collectionName = window.location.href;
      let recoId = getCookie("recoId");
      let productDetailsArray = recommendations?.items?.map(item => item.productDetails);
      // sends product list view event to psyhke  
      const urlRouteTracking = JSON.parse(localStorage.getItem("psykhe-plp") || "{}");

      if (!urlRouteTracking[collectionName]) {
        // sends product list view event to psyhke  
        //if user is logged in then send user id else send null
        var userId = logUser?.userLoggedIn?.id || logUser?.userData?.id;

        if(userId){
          sendProductListViewEvent(collectionName, productDetailsArray, recoId, userId);
          urlRouteTracking[collectionName] = true;
          localStorage.setItem("psykhe-plp", JSON.stringify(urlRouteTracking));
        }
        else{
          sendProductListViewEvent(collectionName, productDetailsArray, recoId, null);
          urlRouteTracking[collectionName] = true;
          localStorage.setItem("psykhe-plp", JSON.stringify(urlRouteTracking));
        }
      }
    }
  }, [recommendations?.items]);

  useEffect(() => {
    // Clean filters for URL
    const cleanedFilters = Object.fromEntries(
      Object.entries(filters).filter(
        ([, v]) => Array.isArray(v) ? v.length > 0 : true
      )
    );
    const url = new URL(window.location.href);
    if (Object.keys(cleanedFilters).length === 0) {
      url.searchParams.delete("filters");
    } else {
      url.searchParams.set("filters", JSON.stringify(cleanedFilters));
    }
    if(apiType !== 'get') {
      window.history.replaceState({}, '', url);
    }
    // Create new recommendations based on sort and filters
    if ((activeSortOption?.setByUser && filters?.setByUser)||activeSortOption?.setByUser) {
      createNewRecommendations(activeSortOption?.key, filters);
    } else if (filters?.setByUser) {
      createNewRecommendations(activeSortOption?.key, filters);
    }

    // If apiType is 'get' and reapplyFilters cookie is set, delete the cookie and create new recommendations, with back button the filters already applied do not have setByUser flag hence above create will be not triggered
    if(getCookie('reapplyFilters')) {
      deleteCookie('reapplyFilters');
      createNewRecommendations(activeSortOption?.key, filters);
    }
  }, [activeSortOption, filters]);

  // Disable content tile for pages other than 1
  enableContentTile = paginationState?.currentPage === 1 ? enableContentTileCheck : false;

  return (
    <>
    <SeoDefinition seoData={seoData} />
    <div className="plp-section auto-plp-container">
      <div className="breadcrumb-container">
      {filters && <BreadCrumb filters={filters} />}
        </div>
      <div className="container">
        <div className="ais-InstantSearch">
          <>
          <StatsComp  seoData={seoData} oliSearch={oliSearch} totalCount={(plpRender) ? recommendations?.totalItems > 0 ? `${recommendations.totalItems} results` : '' :`96 results`} isPsykhe={isPsykhe} />
          </>
          {recommendations?.recoId && <div className="plpQuickLinks">
            {quickLinks?.data && serverPath && <PLPQuickLinks serverPath={serverPath}/>}
          </div>}
          <div ref={filterStartRef}></div>
          {recommendations?.recoId && plpRender && <div ref={filterBarRef} className={`grid-md-12 filter-bar ${isFilterBarFixed ? "fixed_head" : ""} ${isFilterBarFixed && isPWA ? "fixed_top" : ""}`} 
            style={
              isFilterBarFixed && (wishlistSidebarOpen || isMenuVisible || basketSidebarOpen || accountSidebarOpen)
              ? { zIndex: 998 } : undefined
            }
          >
          <div className="filterbar_wrapper">
            <HiddenFiltersContext.Provider value={{ hiddenFilters }}>
              <CustomFilters
                facets={recommendations?.facets}
                onChange={setFilters}
                totalItems={recommendations?.totalItems}
                selected={filters}
                apiType={apiType}
                seoData={seoData}
                isFilterBarFixed={isFilterBarFixed}
              />
              <SelectedFiltersBar selectedFilters={visibleFilters} setFilters={setFilters} />
            </HiddenFiltersContext.Provider>
            <PsykheSortBy
              handleActiveSortOption={(e) => setActiveSortOption({ ...e, setByUser: true })}
              selected={activeSortOption} // Pass the selected sort option to PsykheSortBy
              seoData={seoData}
              isFilterBarFixed={isFilterBarFixed}
            />
            </div>
          </div>}

          <div className="for-plp-loading"></div>
          <div className="ais-InfiniteHits injected-content">
          <ol className="ais-InfiniteHits-list">
            {recommendations?.items?.length > 0 &&
              recommendations?.items?.map((item, index) => {
                // Insert contentTilePLPOne at position1
                if (
                  enableContentTile && paginationState.currentPage === 1 &&
                  contentTilePLPOne &&
                  index === position1
                ) {
                  return (
                    <>
                      <li className="ais-InfiniteHits-item content-tile-plp">
                        <ContentTilePLP1 />
                      </li>
                      <li className="ais-InfiniteHits-item item" id={`product-item-plp-${index}`}>
                        <ProductItemTile {...item} variant={psykheData?.variant} />
                      </li>
                    </>
                  );
                }
                // Insert contentTilePLPTwo at position2
                if (
                  enableContentTile && paginationState.currentPage === 1 &&
                  contentTilePLPTwo &&
                  index === position2
                ) {
                  return (
                    <>
                      <li className="ais-InfiniteHits-item content-tile-plp" id={`product-item-plp-${index}`}>
                        <ContentTilePLP2 />
                      </li>
                      <li className="ais-InfiniteHits-item item" id={`product-item-plp-${index}`}>
                        <ProductItemTile {...item} variant={psykheData?.variant} />
                      </li>
                    </>
                  );
                }
                // Default: just render the product
                return (
                  <li className="ais-InfiniteHits-item item" key={index} id={`product-item-plp-${index}`}>
                    <ProductItemTile {...item} variant={psykheData?.variant} />
                  </li>
                );
              })}
          </ol>
          </div>
          {recommendations?.totalItems > 0 && paginationState.totalPages > 1 && recommendations?.items?.length > 0 ? (
            <CustomMDesktopPagination dispatch={dispatch} paginationState={paginationState} enableContentTile={enableContentTileCheck} plpRender={plpRender} />
          ) : (
            <></>
          )}
          {isPreviewing ? ( <div className="nosto_element pl-none pr-none" id={isNewArrivalsPLP ? "new-arrivals-plp" : isCollectionPLP ? "collection-plp-all" : isDesignerPLP ? "designer-plp-all" : "category-plp-all"}
              ></div>) : recommendations?.recoId && (
                <div className="nosto_element pl-none pr-none" id={isNewArrivalsPLP ? "new-arrivals-plp" : isCollectionPLP ? "collection-plp-all" : isDesignerPLP ? "designer-plp-all" : "category-plp-all"}
              ></div>
          )}

          {/* Load PLP Impact Content */}
          {isPreviewing ? (
                <div
                  className="plp-impact-content"
                  ref={impactContentRef}
                  data-is-previewing={isPreviewing}
                >
                  <BuilderComponent model="plp-impact-content" />
                </div>
              ) : recommendations?.recoId && (
                <div
                  className="plp-impact-content"
                  ref={impactContentRef}
                  data-is-previewing={isPreviewing}
                >
                  {impactContentVisible && <BuilderComponent model="plp-impact-content" />}
                </div>
            )}
        </div>
        
      </div>
    </div>
    </>
  );
};

export default PsykhePLP;
